export class DriverAccountTypeModel {
    id: number;
    name: string;

    constructor () {
        this.id = 0;
        this.name = '';
    }

    public static toJson (obj: any): DriverAccountTypeModel {
        const model = new DriverAccountTypeModel;
        Object.assign(model, {
            id: obj.id,
            name: obj.name
        });
        return model;
    }
}